export const roles = {
  ROLE_ADMIN: "ROLE_ADMIN",
  ROLE_WATCHER: "ROLE_WATCHER",
  ROLE_SUPPORT: "ROLE_SUPPORT",
  ROLE_ANALYZER: "ROLE_ANALYZER",
  ROLE_SUPPORT_L1: "ROLE_SUPPORT_L1",
  ROLE_SUPPORT_L2: "ROLE_SUPPORT_L2",
  ROLE_SUPPORT_L3: "ROLE_SUPPORT_L3",
};
